/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrdersPageSidebarPropTypes from './Orders.page.sidebar.props';
import ordersPageStyles from './Orders.page.styles';

/**
 * OrdersPageSidebarComponent
 * @export
 * @class OrdersPageSidebarComponent
 * @extends {React.Component<OrdersPageSidebarComponentComposedProps, OrdersPageSidebarComponentState>}
 */
export class OrdersPageSidebarComponent extends React.Component {
  preserveScrollRef = React.createRef();

  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<OrdersPageSidebarComponentProps>}
   * @memberof OrdersPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrdersPageSidebar`}
   * @memberof OrdersPageSidebarComponent
   */
  static displayName = `OrdersPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrdersPageSidebarComponent
   */
  static propTypes = OrdersPageSidebarPropTypes;

  /**
   * Data specific to the `<OrdersPageSidebar />` instance
   * @type {OrdersPageSidebarComponentState}
   * @memberof OrdersPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<OrdersPageSidebar />`
   * @memberof OrdersPageSidebarComponent
   */
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.sidebarRoot} ref={this.preserveScrollRef}>
        <UserMenu showAvatar={false} />
      </div>
    );
  }
}

/** @type {React.ComponentClass<OrdersPageSidebarComponentProps>} */
const OrdersPageSidebar = compose(withStyles(themeCreateInjectableStyles(ordersPageStyles), { withTheme: true }))(OrdersPageSidebarComponent);

export default OrdersPageSidebar;
